<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">External System Details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li>
                        <router-link :to="CONTEXT_PATH + '/integrate/externalsystems'">External systems</router-link>
                    </li>
                    <li aria-current="page">Create new</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <transition name="list">
                <div class="mcc-row" v-if="showHelpText">
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact ">
                            <mcc-icon name="info" aria-hidden="true" icon-set="fluency-filled"></mcc-icon>
                            <span>
                                {{ helpText.title }} <a :href="helpText.url" target="_blank">Read more...</a>
                            </span>
                        </mcc-alert>
                    </div>
                </div>
            </transition>
            <div class="mcc-row">
                <div class="mcc-col">
                    <form ref="externalSystemForm"  @submit.prevent="saveExternalSystem()" id="formId" novalidate>

                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h4 class="mu-fw-semi-bold mu-mb-00">Details</h4>
                                </div>
                                <div class="mcc-card__body">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <div class="mfc-input-wrapper mu-d-block mfc-form-input-wrapper--width mfc-form-input-container mu-mb-03">
                                                <label for="name" class="mfc-label--required mu-mb-00">Name</label>
                                                <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" ref="name" :value="dto.name" :pattern="nameWithoutSpaces" @change="updateName($event)">

                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-wrapper--width mfc-form-input-container mu-mb-03">
                                                <label for="description" class="mfc-label--required mu-mb-00">Description</label>
                                                <textarea id="description" name="description" required="" ref="description" placeholder="Description" maxlength="100" :value="dto.description" :pattern="descRegex" @change="updateDescription($event)" @input="dto.description = $event.target.value"></textarea>
                                                <div class="mfc-invalid-feedback"></div>
                                                <span class="mfc-help-text" v-if="dto.description"> You have {{100 - dto.description.length}} characters remaining</span>
                                                <span class="mfc-help-text" v-else> You have 100 characters remaining</span>
                                            </div>
                                            <div>
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mb-03">
                                                    <input type="checkbox" class="mfc-switch" :checked="dto.requiresUserMapping" id="requireMapping" name="requireMapping" @change="updateRequireMapping($event)" color="primary">
                                                    <label for="requireMapping">Requires user mapping ?</label>
                                                </div>
                                            </div>
                                            <div class="mfc-input-wrapper mu-d-block  mfc-form-input-wrapper--width mfc-form-input-container" v-if="dto.requiresUserMapping">
                                                <label for="defaultAliasId" class="mfc-label--required mu-mb-00">Default user name alias</label>
                                                <input type="text" id="defaultAliasId" name="defaultAlias" required="" placeholder="Default user name alias" maxlength="50" ref="dto.defaultAlias" :value="dto.defaultAlias" :pattern="nameRegex" @change="updateDefaultAlias($event)">
                                            </div>
                                            <div class="my-2">
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mt-05" id="supportHierarchyImport" name="supportHierarchyImport" :checked="dto.importHierarchicalGroups" @change="dto.importHierarchicalGroups = $event.target.checked" color="primary">
                                                    <input type="checkbox" id="supportHierarchy" class="mfc-switch">
                                                    <label for="supportHierarchy">Supports hierarchy import ?</label>
                                                </div>
                                            </div>
                                            <div class="mu-d-flex mu-justify-content-end">
                                                <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                                    <router-link :to="CONTEXT_PATH + '/integrate/externalsystems'">
                                                        <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                                            <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                        </button>
                                                    </router-link>
                                                    <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
    
<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '@/formvalid.js';

export default {
    name: "ExternalSystemCreate",
    data() {
        return {
            dto: {
                requiresUserMapping: false,
                description: "",
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["externalsystem.create"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            nameWithoutSpaces: constantMessages.PATTERNS["nameWithoutSpaces"],
            showHelpText: false,
            updateCall: true,
            isValid: true,
            isValidDesc: true,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
    },
    methods: {
        saveExternalSystem() {
            let self = this;
            let form = $('#formId')
            if(!self.isValidDesc){
                return;
            }
            if (this.dto.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
                    {
                        return;
                    }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }     
           
            if (!this.dto.requiresUserMapping) {
                this.dto.defaultAlias = null;
            }
            self.updateCall = false;
            ExternalSystemAPI.saveExternalSystem(this.dto).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "description") {
                            displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.description.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH + "/integrate/externalsystems/" + response.data.id
                        )
                        .catch(err => {});
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else if (!event.target.value.match(this.nameWithoutSpaces)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
                self.isValid = false
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
                self.isValid = true
            }
            self.dto.name = event.target.value;
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.required"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isValidDesc = false
            } else if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isValidDesc = false
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isValidDesc = false
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isValidDesc = true
            }
            self.dto.description = event.target.value;
        },
        updateDefaultAlias(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs['dto.defaultAlias']), constantMessages.MESSAGES["error.defaultAlias.required"])
                self.$refs['dto.defaultAlias'].classList.add("ms-is-invalid")
                self.isValid = false
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs['dto.defaultAlias']), constantMessages.MESSAGES["error.defaultAlias.length"])
                self.$refs['dto.defaultAlias'].classList.add("ms-is-invalid")
                self.isValid = false
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs['dto.defaultAlias']), constantMessages.MESSAGES["error.defaultAlias.invalid"])
                self.$refs['dto.defaultAlias'].classList.add("ms-is-invalid")
                self.isValid = false
            } else {
                self.$refs['dto.defaultAlias'].classList.remove("ms-is-invalid")
                self.isValid = true
            }
            self.dto.defaultAlias = event.target.value
        },
        updateRequireMapping(event) {
            let self = this;
            this.dto.requiresUserMapping = event.target.checked
            if (!event.target.checked) {
                this.dto.defaultAlias = "";
            }
        }
    }
};
</script>
    

